import React, { createContext, useState, ReactNode } from 'react';

interface BreadcrumbContextType {
  breadcrumbs: string[];
  addBreadcrumb: (breadcrumb: string) => void;
  removeBreadcrumb: (breadcrumb: string) => void;
  clearBreadcrumbs: () => void;
  setBreadcrumbs: (breadcrumbs: string[]) => void;
  alertTitle: string | null;
  setAlertTitle: (title: string | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(undefined);

export { BreadcrumbContext };

interface BreadcrumbProviderProps {
  children: ReactNode;
}

export const BreadcrumbProvider: React.FC<BreadcrumbProviderProps> = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<string[]>([]);
  const [alertTitle, setAlertTitle] = useState<string | null>(null);

  const addBreadcrumb = (breadcrumb: string) => {
    setBreadcrumbs(prev => [...prev, breadcrumb]);
  };

  const removeBreadcrumb = (breadcrumb: string) => {
    setBreadcrumbs(prev => prev.filter(b => b !== breadcrumb));
  };

  const clearBreadcrumbs = () => {
    setBreadcrumbs([]);
  };

  return (
    <BreadcrumbContext.Provider value={{ 
      breadcrumbs, 
      addBreadcrumb, 
      removeBreadcrumb, 
      clearBreadcrumbs, 
      setBreadcrumbs,
      alertTitle,
      setAlertTitle
    }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};
